"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollableTableBody = void 0;
const utilities_1 = require("./utilities");
/** Adds styles to make the table body scroll when it overflows.
 *  Supports <div> tables, not actual <table>s.
  */
function useScrollableTableBody(hooks) {
    hooks.getTableProps.push(props => utilities_1.AddStyles(props, { overflow: "auto" }));
    hooks.getTableBodyProps.push(props => utilities_1.AddStyles(props, { display: "inline-block", minWidth: "100%" }));
    hooks.getHeaderGroupProps.push(props => utilities_1.AddStyles(props, { position: 'sticky', top: 0, alignSelf: 'flex-start' }));
    hooks.getHeaderProps.push(props => utilities_1.AddStyles(props, { background: 'white' }));
}
exports.useScrollableTableBody = useScrollableTableBody;
//# sourceMappingURL=scrollable-table-body.js.map